module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#",
      "id": _vm.id_name
    },
    on: {
      "click": _vm.generate_excel
    }
  }, [_vm._t("default", [_vm._v("\n        " + _vm._s(_vm.button_text) + "\n    ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ec0693d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/JsonExcel.vue
// module id = 455
// module chunks = 1